module.exports = __webpack_public_path__ + "img/ar_inter_green.bd1f67d7.svg";